/**
 * Värden som BETYDER frånvaro ska aldrig räknas som innehåll.
 *
 * Skolverkets register använder flera sätt att säga "ingen uppgift":
 * tom sträng, bindestreck, "Ej relevant", "Ej aktuellt", "Uppgift saknas".
 * Tidigare passerade "Ej relevant" som innehåll och fick hela avsnittet
 * "Det här erbjuder skolan" att visas med fyra rader som inte sa något.
 *
 * EN lista, använd överallt där vi avgör om ett fält har innehåll.
 */

/** Textvärden som betyder "ingen uppgift" (jämförs gemenförkortat och trimmat). */
export const BLANK_TEXT_VALUES = [
  "-",
  "–",
  "—",
  "--",
  "0",
  "ej relevant",
  "ej relevanta",
  "ej aktuellt",
  "ej aktuell",
  "ej angivet",
  "ej angiven",
  "ej uppgift",
  "inga uppgifter",
  "ingen uppgift",
  "uppgift saknas",
  "uppgifter saknas",
  "saknas",
  "okänt",
  "okänd",
  "n/a",
  "na",
  "null",
  "undefined",
] as const;

/** true när värdet saknas eller betyder frånvaro. */
export function isBlankValue(value: unknown): boolean {
  if (value === null || value === undefined) return true;
  if (typeof value === "boolean") return value === false;
  if (typeof value === "number") return !Number.isFinite(value) || value === 0;
  if (Array.isArray(value)) return value.every((v) => isBlankValue(v));
  if (typeof value !== "string") return false;
  const norm = value.trim().toLowerCase();
  if (norm.length === 0) return true;
  return (BLANK_TEXT_VALUES as readonly string[]).includes(norm);
}

/** Motsatsen — läses bättre i villkor. */
export function hasValue(value: unknown): boolean {
  return !isBlankValue(value);
}

/** Returnerar strängen om den är innehåll, annars null. */
export function contentOrNull(value: string | null | undefined): string | null {
  return isBlankValue(value) ? null : (value as string).trim();
}
